import React from 'react'
import styles from "./Handler.module.css";

const Handler = ({ name = '', options = [], handle, setHandle, getCathedra, period=[], localName }) => {
  
    const handleSet = (e) => {
    
        if (name == 'Год' && !e) {
          localStorage.removeItem('schema_st');
          localStorage.removeItem('period_st');
        }
    
        localStorage.setItem(localName, e);
        setHandle(e);
      }
      
    const dateAndPeriod = (options, period) => {
        return ([
          options[0],
          options[1],
          options[2],
          options[3],
          options[4],
          { value: `${period.terms[0]?.term_end.split('.')}_`, name: period.terms[0]?.title },
          options[5],
          options[6],
          options[7],
          options[8],
          options[9],
          { value: `${period.terms[1]?.term_end.split('.')}_`, name: period.terms[1]?.title }])
      }
  
    return (
    <div className={styles.wrapper_handle}>
      <div className={styles.titleHendler}>{name}:</div>
      <select
        onChange={(e) => handleSet(e.target.value)}
      >

        {name && name == 'Схема' &&
          <><option value={''}>Не выбрано</option>
            <>{options && options.map((item) => (<option key={item.id} value={item.handle || item.id || localStorage.getItem('schema_st')} selected={item.id == handle ? handle : ''}>{item.handle || item.title}</option>))}</></>
        }

        {
          name && name == 'Месяц' &&
          <><option value={''}>Не выбрано</option>
            <>{options && period && dateAndPeriod(options, period).filter(el => el?.value && el?.name).map((item) => (<option key={item?.value} value={item?.handle || item?.value || localStorage.getItem('period_st')} selected={item.value == handle ? handle : ''}>{item?.handle || item?.name}</option>))}</></>
        }

        {
          name && name == 'Год' &&
          <><option value={''}>Не выбрано</option>
            <>{options && options && [...options].reverse().map((item) => (<option key={item.name} value={item.handle || item.xp_key || localStorage.getItem('year_st')} selected={item.xp_key == handle ? handle : ''}>{item.handle || item.name}</option>))}</></>
        }

      </select>
    </div>
  )
}

export default Handler